import { render, staticRenderFns } from "./bill_detail.vue?vue&type=template&id=0c9d8995&scoped=true"
import script from "./bill_detail.vue?vue&type=script&lang=js"
export * from "./bill_detail.vue?vue&type=script&lang=js"
import style0 from "./bill_detail.vue?vue&type=style&index=0&id=0c9d8995&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9d8995",
  null
  
)

export default component.exports